import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { PHONE_NUMBERS_ACTION_TYPE } from '../actions';

const initialState = [];

const phoneNumbersReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case PHONE_NUMBERS_ACTION_TYPE.GET_PHONE_NUMBERS:
        return payload || state;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default phoneNumbersReducer;
